// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * InterviewR Design System 2026 — semantic tokens (Stitch-aligned).
 * Light defaults; \`.dark\` on <html> switches palette (class strategy).
 * RGB triplets are space-separated for Tailwind: rgb(var(--token) / <alpha>).
 */
:root {
  /* Surfaces */
  --stitch-canvas: 248 250 252;
  --stitch-surface: 255 255 255;
  --stitch-surface-2: 241 245 249;
  --stitch-border: 226 232 240;
  --stitch-overlay: 15 23 42;

  /* Text */
  --stitch-fg: 15 23 42;
  --stitch-fg-soft: 51 65 85;
  --stitch-fg-subtle: 71 85 105;
  --stitch-muted: 100 116 139;

  /* Brand */
  --stitch-primary: 79 70 229;
  --stitch-primary-hover: 67 56 202;
  --stitch-primary-soft: 238 242 255;

  /* Accent (AI / highlights) */
  --stitch-accent: 124 58 237;
  --stitch-accent-hover: 109 40 217;
  --stitch-accent-soft: 245 243 255;

  /* Semantic */
  --stitch-success: 22 163 74;
  --stitch-success-soft: 220 252 231;
  --stitch-warning: 217 119 6;
  --stitch-warning-soft: 254 243 199;
  --stitch-danger: 220 38 38;
  --stitch-danger-soft: 254 226 226;
  --stitch-info: 2 132 199;
  --stitch-info-soft: 224 242 254;

  /* Footer */
  --stitch-footer-bg: 15 23 42;
  --stitch-footer-fg: 248 250 252;
  --stitch-footer-muted: 148 163 184;

  /* Focus */
  --stitch-ring: 79 70 229;

  /* Radii */
  --stitch-radius-sm: 0.25rem;
  --stitch-radius-md: 0.375rem;
  --stitch-radius-lg: 0.5rem;
  --stitch-radius-xl: 0.75rem;
  --stitch-radius-2xl: 1rem;

  /* Shadows */
  --stitch-shadow-card: 0 1px 3px 0 rgb(15 23 42 / 0.06), 0 1px 2px -1px rgb(15 23 42 / 0.06);
  --stitch-shadow-pop: 0 10px 15px -3px rgb(15 23 42 / 0.08), 0 4px 6px -4px rgb(15 23 42 / 0.08);
  --stitch-shadow-modal: 0 25px 50px -12px rgb(15 23 42 / 0.22);

  /* Motion */
  --stitch-ease-out: cubic-bezier(0.33, 1, 0.68, 1);
  --stitch-duration-fast: 150ms;
  --stitch-duration: 200ms;
}

:root.dark {
  --stitch-canvas: 15 23 42;
  --stitch-surface: 30 41 59;
  --stitch-surface-2: 51 65 81;
  --stitch-border: 71 85 105;
  --stitch-overlay: 2 6 23;

  --stitch-fg: 248 250 252;
  --stitch-fg-soft: 226 232 240;
  --stitch-fg-subtle: 203 213 225;
  --stitch-muted: 148 163 184;

  --stitch-primary: 129 140 248;
  --stitch-primary-hover: 165 180 252;
  --stitch-primary-soft: 49 46 129;

  --stitch-accent: 167 139 250;
  --stitch-accent-hover: 196 181 253;
  --stitch-accent-soft: 91 33 182;

  --stitch-success: 74 222 128;
  --stitch-success-soft: 20 83 45;
  --stitch-warning: 250 204 21;
  --stitch-warning-soft: 113 63 18;
  --stitch-danger: 248 113 113;
  --stitch-danger-soft: 127 29 29;
  --stitch-info: 56 189 248;
  --stitch-info-soft: 12 74 110;

  --stitch-footer-bg: 2 6 23;
  --stitch-footer-fg: 248 250 252;
  --stitch-footer-muted: 148 163 184;

  --stitch-ring: 129 140 248;

  --stitch-shadow-card: 0 1px 3px 0 rgb(0 0 0 / 0.35), 0 1px 2px -1px rgb(0 0 0 / 0.35);
  --stitch-shadow-pop: 0 10px 15px -3px rgb(0 0 0 / 0.4), 0 4px 6px -4px rgb(0 0 0 / 0.35);
  --stitch-shadow-modal: 0 25px 50px -12px rgb(0 0 0 / 0.55);
}

@media (prefers-reduced-motion: reduce) {
  :root {
    --stitch-duration-fast: 0ms;
    --stitch-duration: 0ms;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/stitch-tokens.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;;EAE1B,SAAS;EACT,qBAAqB;EACrB,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;;EAE3B,UAAU;EACV,2BAA2B;EAC3B,iCAAiC;EACjC,kCAAkC;;EAElC,6BAA6B;EAC7B,2BAA2B;EAC3B,iCAAiC;EACjC,iCAAiC;;EAEjC,aAAa;EACb,2BAA2B;EAC3B,kCAAkC;EAClC,2BAA2B;EAC3B,kCAAkC;EAClC,0BAA0B;EAC1B,iCAAiC;EACjC,wBAAwB;EACxB,+BAA+B;;EAE/B,WAAW;EACX,4BAA4B;EAC5B,+BAA+B;EAC/B,kCAAkC;;EAElC,UAAU;EACV,wBAAwB;;EAExB,UAAU;EACV,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;;EAEzB,YAAY;EACZ,2FAA2F;EAC3F,+FAA+F;EAC/F,6DAA6D;;EAE7D,WAAW;EACX,iDAAiD;EACjD,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,0BAA0B;EAC1B,wBAAwB;;EAExB,wBAAwB;EACxB,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;;EAE3B,6BAA6B;EAC7B,mCAAmC;EACnC,gCAAgC;;EAEhC,4BAA4B;EAC5B,kCAAkC;EAClC,+BAA+B;;EAE/B,4BAA4B;EAC5B,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;EAChC,4BAA4B;EAC5B,+BAA+B;EAC/B,yBAAyB;EACzB,6BAA6B;;EAE7B,0BAA0B;EAC1B,+BAA+B;EAC/B,kCAAkC;;EAElC,0BAA0B;;EAE1B,qFAAqF;EACrF,wFAAwF;EACxF,0DAA0D;AAC5D;;AAEA;EACE;IACE,2BAA2B;IAC3B,sBAAsB;EACxB;AACF","sourcesContent":["/**\r\n * InterviewR Design System 2026 — semantic tokens (Stitch-aligned).\r\n * Light defaults; `.dark` on <html> switches palette (class strategy).\r\n * RGB triplets are space-separated for Tailwind: rgb(var(--token) / <alpha>).\r\n */\r\n:root {\r\n  /* Surfaces */\r\n  --stitch-canvas: 248 250 252;\r\n  --stitch-surface: 255 255 255;\r\n  --stitch-surface-2: 241 245 249;\r\n  --stitch-border: 226 232 240;\r\n  --stitch-overlay: 15 23 42;\r\n\r\n  /* Text */\r\n  --stitch-fg: 15 23 42;\r\n  --stitch-fg-soft: 51 65 85;\r\n  --stitch-fg-subtle: 71 85 105;\r\n  --stitch-muted: 100 116 139;\r\n\r\n  /* Brand */\r\n  --stitch-primary: 79 70 229;\r\n  --stitch-primary-hover: 67 56 202;\r\n  --stitch-primary-soft: 238 242 255;\r\n\r\n  /* Accent (AI / highlights) */\r\n  --stitch-accent: 124 58 237;\r\n  --stitch-accent-hover: 109 40 217;\r\n  --stitch-accent-soft: 245 243 255;\r\n\r\n  /* Semantic */\r\n  --stitch-success: 22 163 74;\r\n  --stitch-success-soft: 220 252 231;\r\n  --stitch-warning: 217 119 6;\r\n  --stitch-warning-soft: 254 243 199;\r\n  --stitch-danger: 220 38 38;\r\n  --stitch-danger-soft: 254 226 226;\r\n  --stitch-info: 2 132 199;\r\n  --stitch-info-soft: 224 242 254;\r\n\r\n  /* Footer */\r\n  --stitch-footer-bg: 15 23 42;\r\n  --stitch-footer-fg: 248 250 252;\r\n  --stitch-footer-muted: 148 163 184;\r\n\r\n  /* Focus */\r\n  --stitch-ring: 79 70 229;\r\n\r\n  /* Radii */\r\n  --stitch-radius-sm: 0.25rem;\r\n  --stitch-radius-md: 0.375rem;\r\n  --stitch-radius-lg: 0.5rem;\r\n  --stitch-radius-xl: 0.75rem;\r\n  --stitch-radius-2xl: 1rem;\r\n\r\n  /* Shadows */\r\n  --stitch-shadow-card: 0 1px 3px 0 rgb(15 23 42 / 0.06), 0 1px 2px -1px rgb(15 23 42 / 0.06);\r\n  --stitch-shadow-pop: 0 10px 15px -3px rgb(15 23 42 / 0.08), 0 4px 6px -4px rgb(15 23 42 / 0.08);\r\n  --stitch-shadow-modal: 0 25px 50px -12px rgb(15 23 42 / 0.22);\r\n\r\n  /* Motion */\r\n  --stitch-ease-out: cubic-bezier(0.33, 1, 0.68, 1);\r\n  --stitch-duration-fast: 150ms;\r\n  --stitch-duration: 200ms;\r\n}\r\n\r\n:root.dark {\r\n  --stitch-canvas: 15 23 42;\r\n  --stitch-surface: 30 41 59;\r\n  --stitch-surface-2: 51 65 81;\r\n  --stitch-border: 71 85 105;\r\n  --stitch-overlay: 2 6 23;\r\n\r\n  --stitch-fg: 248 250 252;\r\n  --stitch-fg-soft: 226 232 240;\r\n  --stitch-fg-subtle: 203 213 225;\r\n  --stitch-muted: 148 163 184;\r\n\r\n  --stitch-primary: 129 140 248;\r\n  --stitch-primary-hover: 165 180 252;\r\n  --stitch-primary-soft: 49 46 129;\r\n\r\n  --stitch-accent: 167 139 250;\r\n  --stitch-accent-hover: 196 181 253;\r\n  --stitch-accent-soft: 91 33 182;\r\n\r\n  --stitch-success: 74 222 128;\r\n  --stitch-success-soft: 20 83 45;\r\n  --stitch-warning: 250 204 21;\r\n  --stitch-warning-soft: 113 63 18;\r\n  --stitch-danger: 248 113 113;\r\n  --stitch-danger-soft: 127 29 29;\r\n  --stitch-info: 56 189 248;\r\n  --stitch-info-soft: 12 74 110;\r\n\r\n  --stitch-footer-bg: 2 6 23;\r\n  --stitch-footer-fg: 248 250 252;\r\n  --stitch-footer-muted: 148 163 184;\r\n\r\n  --stitch-ring: 129 140 248;\r\n\r\n  --stitch-shadow-card: 0 1px 3px 0 rgb(0 0 0 / 0.35), 0 1px 2px -1px rgb(0 0 0 / 0.35);\r\n  --stitch-shadow-pop: 0 10px 15px -3px rgb(0 0 0 / 0.4), 0 4px 6px -4px rgb(0 0 0 / 0.35);\r\n  --stitch-shadow-modal: 0 25px 50px -12px rgb(0 0 0 / 0.55);\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  :root {\r\n    --stitch-duration-fast: 0ms;\r\n    --stitch-duration: 0ms;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
